import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type CustomerDepartmentStore = {
  selectedDepartmentIds: Record<string, number>;
  selectDepartment: (selectionKey: string, departmentId: number) => void;
};

const useCustomerDepartmentStore = create<CustomerDepartmentStore>()(
  persist(
    (set) => ({
      selectedDepartmentIds: {},
      selectDepartment: (selectionKey, departmentId) =>
        set((state) => ({
          selectedDepartmentIds: { ...state.selectedDepartmentIds, [selectionKey]: departmentId }
        }))
    }),
    {
      name: 'customerDepartmentSelection',
      storage: createJSONStorage(() => localStorage)
    }
  )
);

export const useSelectedDepartmentIds = () => useCustomerDepartmentStore((state) => state.selectedDepartmentIds);
export const useSelectDepartment = () => useCustomerDepartmentStore((state) => state.selectDepartment);
